'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Param = require('./Param');
var Type = require('./Type');

var _require = require('../helpers'),
    flatten = _require.flatten;

var changeCase = require('change-case');

var Function = function () {
  /**
   * Constructor
   * @param {Object} meta
   * @param {Object[]} [calls]
   */
  function Function(meta, calls) {
    var _this = this;

    _classCallCheck(this, Function);

    Object.assign(this, meta);
    this.returns = new Type();
    if (this.comment) {
      this.parseComment();
    } else {
      this.oldParams = {};
      this.description = changeCase.sentenceCase(this.name);
    }

    this.params = this.params.map(function (_ref) {
      var name = _ref.name,
          defaultValue = _ref.defaultValue;
      return Param.create(_this, name, defaultValue);
    });

    if (calls) {
      calls.forEach(function (call) {
        _this.params.forEach(function (param, index) {
          param.addExample(call.params[index]);
        });

        _this.returns.addExample(call.returns);
      });
    }
  }

  /**
   * Parse comment
   */


  _createClass(Function, [{
    key: 'parseComment',
    value: function parseComment() {
      var _this2 = this;

      var lines = this.comment.trim().split('\n').map(function (line) {
        return line.replace(/(\/\/|\/\*|\*\/?)\s*/g, '').trim();
      });
      this.description = lines.filter(function (line) {
        return !line.startsWith('@');
      }).join('\n').trim();

      this.oldParams = lines.filter(function (line) {
        return line.startsWith('@param');
      }).map(function (line) {
        return Param.parse(_this2, line);
      }).reduce(function (acc, curr) {
        acc[curr.fullName] = curr;
        return acc;
      }, {});
    }

    /**
     * To string
     * @returns {string}
     */

  }, {
    key: 'toString',
    value: function toString() {
      var _this3 = this;

      var lines = ['/**', ' * ' + this.description.split('\n').join('\n * ')].concat(_toConsumableArray(flatten(this.params.map(function (param) {
        return param.toArray();
      }))), [this.returns.isDefined && ' * @returns ' + this.returns, ' */']).filter(function (x) {
        return x;
      }).map(function (line) {
        return '' + _this3.indentation + line + '\n';
      });
      return lines.join('');
    }
  }]);

  return Function;
}();

module.exports = Function;


//////////////////
// WEBPACK FOOTER
// ../lib/JSDoc/Function.js
// module id = 497
// module chunks = 0